export default __webpack_public_path__ + "static/media/logo-salesforce.e10f406f.svg";